import { IApp } from "@/types";
import AbstractSource from "./AbstractSource";

class GoogleSearchConsoleSource extends AbstractSource {
  getDataTypes(): IApp.DataType[] {
    return [IApp.DataType.Default];
  }
}

export default GoogleSearchConsoleSource;
